/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationExclusionRuleFilters extends models.RecommendationClassificationFilter {
    getFixupPrototypeFunction() { return RecommendationExclusionRuleFilters.fixupPrototype; }

    static newInstance(model: Partial<RecommendationExclusionRuleFilters>): RecommendationExclusionRuleFilters {
        let obj = Object.assign(new RecommendationExclusionRuleFilters(), model);
        RecommendationExclusionRuleFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationExclusionRuleFilters>): RecommendationExclusionRuleFilters {
        if (!model) return null;
        return RecommendationExclusionRuleFilters.newInstance(<RecommendationExclusionRuleFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationExclusionRuleFilters) {
        if (!obj) return;

        models.RecommendationExclusionRuleFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationExclusionRuleFilters): boolean {
        if (models.RecommendationClassificationFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationExclusionRuleFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Search based on name, classification, sub_classification
     */
    search: string;

}
